import {createSlice} from "@reduxjs/toolkit";
import {errorConverter, errorConverterFields} from "../../common/formater";
import {IDLE, LOADING, SUCCESS, FAILED} from "../../common/statuses";
import {initialState} from "./initState";
import {
    changeState,
    deleteGroup, deleteStudentFromGroup,
    getGroupById,
    getGroups, getHomework, getHomeworkByGroupIdAndUserId,
    getLog, GROUPS,
    saveAllVisits,
    saveGroup, saveHW,
    saveStudent, transferStudent
} from "./groupService";

export const CLOSE = "close";
export const CANCEL = "cancel";

const groupsSlice = createSlice({
    name: GROUPS,
    initialState,
    reducers: {
        setEmpty: () => {
            return {...initialState}
        },
        removeSelected: (state) => {
            return {
                ...state,
                selected: {
                    data: undefined,
                    status: IDLE,
                }
            }
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getGroups.pending, (state) => {
                state.getGroups.status = LOADING
            })
            .addCase(getGroups.fulfilled, (state, action) => {
                state.getGroups.status = SUCCESS
                state.getGroups.data = action.payload
            })
            .addCase(getGroups.rejected, (state) => {
                state.getGroups.status = FAILED
            })
            // ---------------------------------------------------------------
            .addCase(getGroupById.pending, (state) => {
                state.selected.status = LOADING
            })
            .addCase(getGroupById.fulfilled, (state, action) => {
                state.selected.status = SUCCESS
                state.selected.data = action.payload
            })
            .addCase(getGroupById.rejected, (state) => {
                state.selected.status = FAILED
            })
            // ---------------------------------------------------------------
            .addCase(saveGroup.pending, (state) => {
                state.save.status = LOADING
            })
            .addCase(saveGroup.fulfilled, (state, action) => {
                state.save.status = SUCCESS
                state.selected.data = action.payload
            })
            .addCase(saveGroup.rejected, (state, action) => {
                state.save.status = FAILED
                state.save.errors = errorConverterFields(action)
            })
            // ---------------------------------------------------------------
            .addCase(deleteGroup.pending, (state) => {
                state.delete.status = LOADING
            })
            .addCase(deleteGroup.fulfilled, (state) => {
                state.delete.status = SUCCESS
            })
            .addCase(deleteGroup.rejected, (state) => {
                state.delete.status = FAILED
            })
            // ---------------------------------------------------------------
            .addCase(changeState.pending, (state) => {
                state.changeState.status = LOADING
            })
            .addCase(changeState.fulfilled, (state) => {
                state.changeState.status = SUCCESS
            })
            .addCase(changeState.rejected, (state, action) => {
                state.changeState.status = FAILED
                state.changeState.errors = errorConverter(action)
            })
            // ---------------------------------------------------------------
            .addCase(getLog.pending, (state) => {
                state.changeState.status = LOADING
            })
            .addCase(getLog.fulfilled, (state, action) => {
                state.getLog.status = SUCCESS

                const visits = action.payload;

                const uniqDates = [...new Set(visits.map(visit => {
                    const {lesson} = visit;
                    return lesson.date
                }))].sort();
                const uniqStudents = [...new Map(visits.map(visit => {
                    const {student} = visit;
                    return [student.id, student]
                })).values()].sort((o1, o2) => {
                    const o1name = `${o1.lastname} ${o1.firstName} ${o1.middleName}`
                    const o2name = `${o2.lastname} ${o2.firstName} ${o2.middleName}`

                    return o1name.toLowerCase() > o2name.toLowerCase()
                        ? -1
                        : o1name.toLowerCase() < o2name.toLowerCase() ? 1 : 0
                });

                state.getLog.data = {
                    students: uniqStudents,
                    dates: uniqDates,
                    visits: visits
                }
            })
            .addCase(getLog.rejected, (state) => {
                state.getLog.status = FAILED
                // state.save.errors = errorConverter(action)
            })
        // ---------------------------------------------------------------
            .addCase(saveAllVisits.pending, (state) => {
                state.saveVisits.status = LOADING
            })
            .addCase(saveAllVisits.fulfilled, (state) => {
                state.saveVisits.status = SUCCESS
                state.saveVisits.message = 'Сохранено'
            })
            .addCase(saveAllVisits.rejected, (state, action) => {
                state.saveVisits.status = FAILED
                state.saveVisits.message = errorConverter(action)
            })
        // ---------------------------------------------------------------
            .addCase(saveStudent.pending, (state) => {
                state.saveStudent.status = LOADING
                state.saveStudent.errors = undefined;
            })
            .addCase(saveStudent.fulfilled, (state) => {
                state.saveStudent.status = SUCCESS
            })
            .addCase(saveStudent.rejected, (state, action) => {
                console.log("rejected", action)
                state.saveStudent.status = FAILED
                state.saveStudent.errors = errorConverterFields(action)
            })
        // ---------------------------------------------------------------
            .addCase(saveHW.pending, (state) => {
                state.saveHW.status = LOADING
                state.saveHW.message = undefined;
            })
            .addCase(saveHW.fulfilled, (state) => {
                state.saveHW.status = SUCCESS
                state.saveHW.message = 'Сохранено'
            })
            .addCase(saveHW.rejected, (state) => {
                state.saveHW.status = FAILED
                state.saveHW.message = "Не заполнено поле Тема или Как решать"
            })
        // ---------------------------------------------------------------
            .addCase(getHomework.pending, (state) => {
                state.getHomeworks.status = LOADING
            })
            .addCase(getHomework.fulfilled, (state, action) => {
                state.getHomeworks.status = SUCCESS
                state.getHomeworks.data = action.payload
            })
            .addCase(getHomework.rejected, (state) => {
                state.getHomeworks.status = FAILED
            })
        // ---------------------------------------------------------------
            .addCase(getHomeworkByGroupIdAndUserId.pending, (state) => {
                state.getHomework.status = LOADING
            })
            .addCase(getHomeworkByGroupIdAndUserId.fulfilled, (state, action) => {
                state.getHomework.status = SUCCESS
                state.getHomework.data = action.payload
            })
            .addCase(getHomeworkByGroupIdAndUserId.rejected, (state) => {
                state.getHomework.status = FAILED
            })
        // ---------------------------------------------------------------
            .addCase(transferStudent.pending, ({transferStudent}) => {
                transferStudent.status = LOADING
            })
            .addCase(transferStudent.fulfilled, ({transferStudent}) => {
                transferStudent.status = SUCCESS
                transferStudent.message = "Ученик перенесён успешно"
            })
            .addCase(transferStudent.rejected, ({transferStudent}, action) => {
                transferStudent.status = FAILED
                transferStudent.message = errorConverter(action.payload)
            })
        // ---------------------------------------------------------------
            .addCase(deleteStudentFromGroup.pending, ({deleteStudentFromGroup}) => {
                deleteStudentFromGroup.status = LOADING
            })
            .addCase(deleteStudentFromGroup.fulfilled, ({deleteStudentFromGroup}) => {
                deleteStudentFromGroup.status = SUCCESS
                deleteStudentFromGroup.message = "Ученик удалён из группы успешно"
            })
            .addCase(deleteStudentFromGroup.rejected, ({deleteStudentFromGroup}, action) => {
                deleteStudentFromGroup.status = FAILED
                deleteStudentFromGroup.message = errorConverter(action.payload)
            })
        // ---------------------------------------------------------------
    }
})

export const {setEmpty, removeSelected} = groupsSlice.actions

export default groupsSlice.reducer